
import { UpdateStandardReturnStateParameter } from "@dana/Services/DanaStandardReturnOrderService";
import updateFreightCollectInfo from "@dana/Store/Data/StandardReturns/Handlers/UpdateFreightCollectInfoHandler";
import { DanaStandardReturnOrderActions } from "@dana/Store/Data/StandardReturns/Reducers/GetStandardReturnOrderReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<UpdateStandardReturnStateParameter,
    DispatchProp<DanaStandardReturnOrderActions>
>;

export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "StandardReturn/UpdateDisposition",
        disposition: props.parameter.disposition,
    } as any);
    
};
export const chain = [DispatchSetParameters];

const updateDisposition = createHandlerChainRunner(chain, "UpdateDispositionHandler");
export default updateDisposition;